import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../hooks";


interface CustomComponentProps {
  iconPath: string;
  text: string;
  value: string | number;
  backgroundColor: string;
  color: string;
}

const CustomInfos: React.FC<CustomComponentProps> = ({
  iconPath,
  text,
  value,
  backgroundColor,
  color,
}) => {
  const formatValue = (val: string | number): string => {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    return !isNaN(num)
      ? new Intl.NumberFormat('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num)
      : val.toString();
  };

  const formattedValue = formatValue(value);

  const direction = useAppSelector((state) => state.languageSlice.direction);
  
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: backgroundColor,
        color: color,
        justifyContent: 'space-between',
        padding: '0.5% 1%',
        direction: direction === 'rtl' ? 'rtl' : 'ltr'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <img src={iconPath} alt={text} width="24" height="24" />
        <Typography variant="h7" pl={1} sx={{ paddingRight: '8px' }}>
          {text}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box sx={{
          direction: direction == 'ltr' ? 'ltr':'ltr'
        }}>
        <Typography variant="body1" >{formattedValue}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomInfos;
